<template>
	<div v-if="active_pdf" class="viewer">
		<div class="viewer-bg" @click="close()"></div>
		<div class="viewer-content">
			<pdf-file :pdf_src="active_study.url" />
			<div class="close-button" @click="close()"><icon file="x" :size="24" /></div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import PdfFile from '@/components/etude/pdf-file'


export default {
	name: 'viewer',
	data: function() {
		return {
			
		}
	},
	computed: Object.assign(mapGetters([ 'active_pdf', 'active_study' ]), {

	}),
	methods: {
		close: function() {
			this.$store.dispatch('set_active_pdf', { active_pdf: false })
		}
	},
	components: { PdfFile }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/app'

.viewer
	position fixed
	left 0
	top 0
	right 0
	bottom 0
	z-index 10001
	.viewer-bg
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		background-color alpha(#000, 20%)
	.viewer-content
		position absolute
		left 50%
		top 24px
		height calc(100% - 48px)
		width 1000px
		margin-left -(@width / 2)
		box-shadow 0 0 8px alpha(#000, 50%)
		.close-button
			position absolute
			top -8px
			right -8px
			background #eee
			color #666
			padding 4px
			border-radius 100%
			cursor pointer
			z-index 10
			box-shadow 0 0 8px alpha(#000, 50%)
			&:hover
				background-color red
				color #fff

</style>
